const e=e=>new Promise((o=>{setTimeout((()=>o()),e)}));export{e as delay};
